/**
 * ENUM que define os tipos de documentos de uma pessoa.
 */
export enum PersonDocumentEnum {
    ID_FRONT = 'ID_FRONT',
    ID_BACK = 'ID_BACK',
    SELFIE = 'SELFIE',
    PHOTO_HOLDING_ID = 'PHOTO_HOLDING_ID'
}
